<template>
  <div>
    <v-container class="content-wrapper" fluid id="suggested-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex">
          <v-btn-toggle v-model="toggleSuggested" rounded mandatory>
            <v-btn value="equipment" class="btn-selected">
              Equipment
            </v-btn>
            <v-btn value="services" class="btn-selected">
              Services
            </v-btn>
            <v-btn value="intellectualProperties" class="btn-selected">
              Intellectual Properties
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Equipment -->
      <v-row v-if="toggleSuggested === 'equipment'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <h2 class="black--text font-weight-bold">
            Equipment
          </h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleSuggested === 'equipment'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <div>
            <SuggestedEquipment></SuggestedEquipment>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Intellectual Properties -->
      <v-row
        justify="start"
        align="center"
        v-if="toggleSuggested == 'intellectualProperties'"
        class="mt-5"
      >
        <v-row id="filtering-toggle">
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" class="justify-center d-flex">
            <v-btn-toggle v-model="toggleIntellectualProperties" rounded mandatory>
              <v-btn value="patents" class="btn-selected">
                Patents
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-row>
      <v-row
        v-if="
          toggleSuggested == 'intellectualProperties' && toggleIntellectualProperties == 'patents'
        "
      >
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <h2 class="black--text font-weight-bold">
            Patents
          </h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row
        justify="center"
        align="center"
        v-if="
          toggleSuggested == 'intellectualProperties' && toggleIntellectualProperties == 'patents'
        "
      >
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <div>
            <SuggestedPatents></SuggestedPatents>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Services -->
      <v-row v-if="toggleSuggested === 'services'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <h2 class="black--text font-weight-bold">
            Services
          </h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleSuggested === 'services'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <div>
            <MarketplaceServicesComponent :suggested="true"></MarketplaceServicesComponent>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MarketplaceServicesComponent from '@/components/marketplace/MarketplaceResourcesComponent';
import SuggestedEquipment from './SuggestedEquipment.vue';
import SuggestedPatents from './SuggestedPatents.vue';
import util from '@/mixins/util';

export default {
  name: 'Suggested',
  mixins: [util],
  components: { MarketplaceServicesComponent, SuggestedEquipment, SuggestedPatents },
  data: () => ({
    toggleSuggested: 'equipment',
    toggleIntellectualProperties: 'patents',
  }),
  watch: {
    '$route.query.toggleOrder'(newValue) {
      if (newValue === 'services') {
        this.toggleSuggested = newValue;
      }
    },
  },
  mounted() {
    if (this.$route.query.toggleOrder) {
      this.toggleSuggested = this.$route.query.toggleOrder;
    }
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
